<script>
import {Bar} from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    assetData: {},
  },
  computed: {
    sumLoad1: function () {
      return this.assetData.heavyLoad1 + this.assetData.maxLoad1 + this.assetData.lightLoad1
    },
    sumLoad2: function () {
      return this.assetData.heavyLoad2 + this.assetData.maxLoad2 + this.assetData.lightLoad2
    },

    calcBasic: function () {
      return this.assetData.beforeBasic - this.assetData.afterBasic1 - this.assetData.afterBasic2
    },
    calcHeavyLoad: function () {
      return this.assetData.beforeHeavyLoad - this.assetData.afterHeavyLoad1 - this.assetData.afterHeavyLoad2
    },
    calcMaxLoad: function () {
      return this.assetData.beforeMaxLoad - this.assetData.afterMaxLoad1 - this.assetData.afterMaxLoad2
    },
    calcLightLoad: function () {
      return this.assetData.beforeLightLoad - this.assetData.afterLightLoad1 - this.assetData.afterLightLoad2
    },

    sumBeforeLoad: function () {
      return this.assetData.beforeHeavyLoad + this.assetData.beforeMaxLoad + this.assetData.beforeLightLoad + this.assetData.beforeEnvironment
    },
    sumAfterLoad1: function () {
      return this.assetData.afterHeavyLoad1 + this.assetData.afterMaxLoad1 + this.assetData.afterLightLoad1 + this.assetData.afterEnvironment1
    },
    sumAfterLoad2: function () {
      return this.assetData.afterHeavyLoad2 + this.assetData.afterMaxLoad2 + this.assetData.afterLightLoad2 + this.assetData.afterEnvironment2
    },
    calcEnvironment: function () {
      return this.assetData.beforeEnvironment - this.assetData.afterEnvironment1 - this.assetData.afterEnvironment2
    },

    calcSumLoad: function () {
      return this.sumBeforeLoad - this.sumAfterLoad1 - this.sumAfterLoad2
    },
    calcPowerFactor: function () {
      return this.assetData.beforePowerFactor - this.assetData.afterPowerFactor1 - this.assetData.afterPowerFactor2
    },
    calcAutoDiscount: function () {
      return this.assetData.beforeAutoDiscount - this.assetData.afterAutoDiscount1 - this.assetData.afterAutoDiscount2
    },
    calcClimate: function () {
      return this.assetData.beforeClimate - this.assetData.afterClimate1 - this.assetData.afterClimate2
    },
    calcFuelAdjust: function () {
      return this.assetData.beforeFuelAdjust - this.assetData.afterFuelAdjust1 - this.assetData.afterFuelAdjust2
    },

    beforeVat: function () {
      return Math.round((this.assetData.beforeBasic + this.sumBeforeLoad + this.assetData.beforePowerFactor + this.assetData.beforeAutoDiscount + this.assetData.beforeClimate + this.assetData.beforeFuelAdjust) * 0.1)
    },
    afterVat1: function () {
      return Math.round((this.assetData.afterBasic1 + this.sumAfterLoad1 + this.assetData.afterPowerFactor1 + this.assetData.afterAutoDiscount1 + this.assetData.afterClimate1 + this.assetData.afterFuelAdjust1) * 0.1)
    },
    afterVat2: function () {
      return Math.round((this.assetData.afterBasic2 + this.sumAfterLoad2 + this.assetData.afterPowerFactor2 + this.assetData.afterAutoDiscount2 + this.assetData.afterClimate2 + this.assetData.afterFuelAdjust2) * 0.1)
    },
    calcVat: function () {
      return this.beforeVat - this.afterVat1 - this.afterVat2
    },
    beforeElectricFund: function () {
      return Math.floor((this.assetData.beforeBasic + this.sumBeforeLoad + this.assetData.beforePowerFactor + this.assetData.beforeAutoDiscount + this.assetData.beforeClimate + this.assetData.beforeFuelAdjust) * 0.032 / 10) * 10
    },
    afterElectricFund1: function () {
      return Math.floor((this.assetData.afterBasic1 + this.sumAfterLoad1 + this.assetData.afterPowerFactor1 + this.assetData.afterAutoDiscount1 + this.assetData.afterClimate1 + this.assetData.afterFuelAdjust1) * 0.032 / 10) * 10
    },
    afterElectricFund2: function () {
      return Math.floor((this.assetData.afterBasic2 + this.sumAfterLoad2 + this.assetData.afterPowerFactor2 + this.assetData.afterAutoDiscount2 + this.assetData.afterClimate2 + this.assetData.afterFuelAdjust2) * 0.032 / 10) * 10
    },
    calcElectricFund: function () {
      return this.beforeElectricFund - this.afterElectricFund1 - this.afterElectricFund2
    },
    beforeMonthBill: function () {
      return Number(this.assetData.beforeBasic + this.sumBeforeLoad + this.assetData.beforePowerFactor + this.assetData.beforeAutoDiscount + this.assetData.beforeClimate + this.assetData.beforeFuelAdjust + this.beforeVat + this.beforeElectricFund)
    },
    afterMonthBill1: function () {
      return Number(this.assetData.afterBasic1 + this.sumAfterLoad1 + this.assetData.afterPowerFactor1 + this.assetData.afterAutoDiscount1 + this.assetData.afterClimate1 + this.assetData.afterFuelAdjust1 + this.afterVat1 + this.afterElectricFund1)
    },
    afterMonthBill2: function () {
      return Number(this.assetData.afterBasic2 + this.sumAfterLoad2 + this.assetData.afterPowerFactor2 + this.assetData.afterAutoDiscount2 + this.assetData.afterClimate2 + this.assetData.afterFuelAdjust2 + this.afterVat2 + this.afterElectricFund2)
    },
    calcMonthBill: function () {
      return this.beforeMonthBill - this.afterMonthBill1 - this.afterMonthBill2
    },

    calcTvLicense: function () {
      return this.assetData.beforeTvLicense - this.assetData.afterTvLicense1 - this.assetData.afterTvLicense2
    },
    beforeCutWon: function () {
      return (this.beforeMonthBill + this.assetData.beforeTvLicense) % 10 * -1
    },
    afterCutWon1: function () {
      return (this.afterMonthBill1 + this.assetData.afterTvLicense1) % 10 * -1
    },
    afterCutWon2: function () {
      return (this.afterMonthBill2 + this.assetData.afterTvLicense2) % 10 * -1
    },
    calcCutWon: function () {
      return this.beforeCutWon + this.afterCutWon1 + this.afterCutWon2
    },

    beforeTotalBill: function () {
      return Number(this.beforeMonthBill) + Number(this.assetData.beforeTvLicense) + Number(this.beforeCutWon)
    },
    afterTotalBill1: function () {
      return Number(this.afterMonthBill1) + Number(this.assetData.afterTvLicense1) + Number(this.afterCutWon1)
    },
    afterTotalBill2: function () {
      return Number(this.afterMonthBill2) + Number(this.assetData.afterTvLicense2) + Number(this.afterCutWon2)
    },
    calcTotalBill: function () {
      return this.beforeTotalBill - this.afterTotalBill1 - this.afterTotalBill2
    },
    resultSavingAmountRate: function () {
      return Math.round((this.beforeTotalBill - this.afterTotalBill1 - this.afterTotalBill2) / this.beforeTotalBill * 10000) / 100
    },
    resultSavingAmount: function () {
      return (this.beforeTotalBill - this.afterTotalBill1 - this.afterTotalBill2) - (this.beforeVat - this.afterVat1 - this.afterVat2)
    },
    resultFee: function () {
      return Math.floor(this.resultSavingAmount * 0.5 / 10000) * 10000
    },
    resultVat: function () {
      return this.resultFee * 0.1
    }
  },
  created: function () {
  },
  mounted: function () {
    const chartData = {
      labels: ['기본요금', '전력량요금(합계)', '중부하 요금', '최대부하 요금', '경부하 요금', '환경비용 차감', '자동이체 할인', '연료비 조정액', '전력 기금', '당월 청구요금'],
      datasets: [
        {
          label: '컨설팅 전',
          borderWidth: 1,
          borderColor: '#91B24F',
          backgroundColor: 'rgba(145, 178, 79, 0.4)',
          data: [
            this.assetData.beforeBasic,
            this.sumBeforeLoad,
            this.assetData.beforeHeavyLoad,
            this.assetData.beforeMaxLoad,
            this.assetData.beforeLightLoad,
            this.assetData.beforeEnvironment,
            this.assetData.beforeAutoDiscount,
            this.assetData.beforeFuelAdjust,
            this.beforeElectricFund,
            this.beforeTotalBill
          ]
        },
        {
          label: '컨설팅 후(II)',
          borderWidth: 1,
          borderColor: '#42A2BF',
          backgroundColor: 'rgba(66,162,191,0.4)',
          data: [
            this.assetData.afterBasic1,
            this.sumAfterLoad1,
            this.assetData.afterHeavyLoad1,
            this.assetData.afterMaxLoad1,
            this.assetData.afterLightLoad1,
            this.assetData.afterEnvironment1,
            this.assetData.afterAutoDiscount1,
            this.assetData.afterFuelAdjust1,
            this.afterElectricFund1,
            this.afterTotalBill1
          ]
        },
        {
          label: '컨설팅 후(III)',
          borderWdith: 1,
          borderColor: '#C15856',
          backgroundColor: 'rgba(193,88,86,0.4)',
          data: [
            this.assetData.afterBasic2,
            this.sumAfterLoad2,
            this.assetData.afterHeavyLoad2,
            this.assetData.afterMaxLoad2,
            this.assetData.afterLightLoad2,
            this.assetData.afterEnvironment2,
            this.assetData.afterAutoDiscount2,
            this.assetData.afterFuelAdjust2,
            this.afterElectricFund2,
            this.afterTotalBill2
          ]
        }
      ],
    }

    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              callback: function (value) {
                return value / 10000 + '만'
              }
            }
          }
        ]
      }
    }

    if (this.assetData.customerType === 1) {
      chartData.datasets.splice(2, 1)
    }


    this.renderChart(chartData, options)
  }
}

// import {Bar} from 'vue-chartjs'
//
// export default {
//   extends: Bar,
//   props: {
//     assetData: {},
//   },
//   data: function () {
//     return {
//     }
//   },
//   computed: {
//     sumLoad1: function () {
//       return this.assetData.heavyLoad1 + this.assetData.maxLoad1 + this.assetData.lightLoad1
//     },
//     sumLoad2: function () {
//       return this.assetData.heavyLoad2 + this.assetData.maxLoad2 + this.assetData.lightLoad2
//     },
//
//     calcBasic: function () {
//       return this.assetData.beforeBasic - this.assetData.afterBasic1 - this.assetData.afterBasic2
//     },
//     calcHeavyLoad: function () {
//       return this.assetData.beforeHeavyLoad - this.assetData.afterHeavyLoad1 - this.assetData.afterHeavyLoad2
//     },
//     calcMaxLoad: function () {
//       return this.assetData.beforeMaxLoad - this.assetData.afterMaxLoad1 - this.assetData.afterMaxLoad2
//     },
//     calcLightLoad: function () {
//       return this.assetData.beforeLightLoad - this.assetData.afterLightLoad1 - this.assetData.afterLightLoad2
//     },
//
//     sumBeforeLoad: function () {
//       return this.assetData.beforeHeavyLoad + this.assetData.beforeMaxLoad + this.assetData.beforeLightLoad + this.assetData.beforeEnvironment
//     },
//     sumAfterLoad1: function () {
//       return this.assetData.afterHeavyLoad1 + this.assetData.afterMaxLoad1 + this.assetData.afterLightLoad1 + this.assetData.afterEnvironment1
//     },
//     sumAfterLoad2: function () {
//       return this.assetData.afterHeavyLoad2 + this.assetData.afterMaxLoad2 + this.assetData.afterLightLoad2 + this.assetData.afterEnvironment2
//     },
//     calcEnvironment: function () {
//       return this.assetData.beforeEnvironment - this.assetData.afterEnvironment1 - this.assetData.afterEnvironment2
//     },
//
//     calcSumLoad: function () {
//       return this.sumBeforeLoad - this.sumAfterLoad1 - this.sumAfterLoad2
//     },
//     calcPowerFactor: function () {
//       return this.assetData.beforePowerFactor - this.assetData.afterPowerFactor1 - this.assetData.afterPowerFactor2
//     },
//     calcAutoDiscount: function () {
//       return this.assetData.beforeAutoDiscount - this.assetData.afterAutoDiscount1 - this.assetData.afterAutoDiscount2
//     },
//     calcClimate: function () {
//       return this.assetData.beforeClimate - this.assetData.afterClimate1 - this.assetData.afterClimate2
//     },
//     calcFuelAdjust: function () {
//       return this.assetData.beforeFuelAdjust - this.assetData.afterFuelAdjust1 - this.assetData.afterFuelAdjust2
//     },
//
//     beforeVat: function () {
//       return Math.round((this.assetData.beforeBasic + this.sumBeforeLoad + this.assetData.beforePowerFactor + this.assetData.beforeAutoDiscount + this.assetData.beforeClimate + this.assetData.beforeFuelAdjust) * 0.1)
//     },
//     afterVat1: function () {
//       return Math.round((this.assetData.afterBasic1 + this.sumAfterLoad1 + this.assetData.afterPowerFactor1 + this.assetData.afterAutoDiscount1 + this.assetData.afterClimate1 + this.assetData.afterFuelAdjust1) * 0.1)
//     },
//     afterVat2: function () {
//       return Math.round((this.assetData.afterBasic2 + this.sumAfterLoad2 + this.assetData.afterPowerFactor2 + this.assetData.afterAutoDiscount2 + this.assetData.afterClimate2 + this.assetData.afterFuelAdjust2) * 0.1)
//     },
//     calcVat: function () {
//       return this.beforeVat - this.afterVat1 - this.afterVat2
//     },
//     beforeElectricFund: function () {
//       return Math.floor((this.assetData.beforeBasic + this.sumBeforeLoad + this.assetData.beforePowerFactor + this.assetData.beforeAutoDiscount + this.assetData.beforeClimate + this.assetData.beforeFuelAdjust) * 0.032 / 10) * 10
//     },
//     afterElectricFund1: function () {
//       return Math.floor((this.assetData.afterBasic1 + this.sumAfterLoad1 + this.assetData.afterPowerFactor1 + this.assetData.afterAutoDiscount1 + this.assetData.afterClimate1 + this.assetData.afterFuelAdjust1) * 0.032 / 10) * 10
//     },
//     afterElectricFund2: function () {
//       return Math.floor((this.assetData.afterBasic2 + this.sumAfterLoad2 + this.assetData.afterPowerFactor2 + this.assetData.afterAutoDiscount2 + this.assetData.afterClimate2 + this.assetData.afterFuelAdjust2) * 0.032 / 10) * 10
//     },
//     calcElectricFund: function () {
//       return this.beforeElectricFund - this.afterElectricFund1 - this.afterElectricFund2
//     },
//     beforeMonthBill: function () {
//       return Number(this.assetData.beforeBasic + this.sumBeforeLoad + this.assetData.beforePowerFactor + this.assetData.beforeAutoDiscount + this.assetData.beforeClimate + this.assetData.beforeFuelAdjust + this.beforeVat + this.beforeElectricFund)
//     },
//     afterMonthBill1: function () {
//       return Number(this.assetData.afterBasic1 + this.sumAfterLoad1 + this.assetData.afterPowerFactor1 + this.assetData.afterAutoDiscount1 + this.assetData.afterClimate1 + this.assetData.afterFuelAdjust1 + this.afterVat1 + this.afterElectricFund1)
//     },
//     afterMonthBill2: function () {
//       return Number(this.assetData.afterBasic2 + this.sumAfterLoad2 + this.assetData.afterPowerFactor2 + this.assetData.afterAutoDiscount2 + this.assetData.afterClimate2 + this.assetData.afterFuelAdjust2 + this.afterVat2 + this.afterElectricFund2)
//     },
//     calcMonthBill: function () {
//       return this.beforeMonthBill - this.afterMonthBill1 - this.afterMonthBill2
//     },
//
//     calcTvLicense: function () {
//       return this.assetData.beforeTvLicense - this.assetData.afterTvLicense1 - this.assetData.afterTvLicense2
//     },
//     beforeCutWon: function () {
//       return (this.beforeMonthBill + this.assetData.beforeTvLicense) % 10 * -1
//     },
//     afterCutWon1: function () {
//       return (this.afterMonthBill1 + this.assetData.afterTvLicense1) % 10 * -1
//     },
//     afterCutWon2: function () {
//       return (this.afterMonthBill2 + this.assetData.afterTvLicense2) % 10 * -1
//     },
//     calcCutWon: function () {
//       return this.beforeCutWon + this.afterCutWon1 + this.afterCutWon2
//     },
//
//     beforeTotalBill: function () {
//       return Number(this.beforeMonthBill) + Number(this.assetData.beforeTvLicense) + Number(this.beforeCutWon)
//     },
//     afterTotalBill1: function () {
//       return Number(this.afterMonthBill1) + Number(this.assetData.afterTvLicense1) + Number(this.afterCutWon1)
//     },
//     afterTotalBill2: function () {
//       return Number(this.afterMonthBill2) + Number(this.assetData.afterTvLicense2) + Number(this.afterCutWon2)
//     },
//     calcTotalBill: function () {
//       return this.beforeTotalBill - this.afterTotalBill1 - this.afterTotalBill2
//     },
//     resultSavingAmountRate: function () {
//       return Math.round((this.beforeTotalBill - this.afterTotalBill1 - this.afterTotalBill2) / this.beforeTotalBill * 10000) / 100
//     },
//     resultSavingAmount: function () {
//       return (this.beforeTotalBill - this.afterTotalBill1 - this.afterTotalBill2) - (this.beforeVat - this.afterVat1 - this.afterVat2)
//     },
//     resultFee: function () {
//       return Math.floor(this.resultSavingAmount * 0.5 / 10000) * 10000
//     },
//     resultVat: function () {
//       return this.resultFee * 0.1
//     }
//   },
//   created: async function () {
//     this.$EventBus.$emit('HeaderBar.setTitleName', `[${this.assetYear}년 ${this.assetMonth}월] 전기요금 컨설팅 차트`)
//     // await this.getAssetData()
//     this.createDataSets()
//   },
//   methods: {
//     createDataSets: function () {
//       const chartData = {
//         labels: ['기본요금', '전력량요금(합계)', '중부하 요금', '최대부하 요금', '경부하 요금', '환경비용 차감', '자동이체 할인', '연료비 조정액', '전력 기금', '당월 청구요금'],
//         datasets: [
//           {
//             label: '컨설팅 전',
//             backgroundColor: '#91B24F',
//             data: [
//               this.assetData.beforeBasic,
//               this.sumBeforeLoad,
//               this.assetData.beforeHeavyLoad,
//               this.assetData.beforeMaxLoad,
//               this.assetData.beforeLightLoad,
//               this.assetData.beforeEnvironment,
//               this.assetData.beforeAutoDiscount,
//               this.assetData.beforeFuelAdjust,
//               this.beforeElectricFund,
//               this.beforeTotalBill
//             ]
//           },
//           {
//             label: '컨설팅 후(II)',
//             backgroundColor: '#42A2BF',
//             data: [
//               this.assetData.afterBasic1,
//               this.sumAfterLoad1,
//               this.assetData.afterHeavyLoad1,
//               this.assetData.afterMaxLoad1,
//               this.assetData.afterLightLoad1,
//               this.assetData.afterEnvironment1,
//               this.assetData.afterAutoDiscount1,
//               this.assetData.afterFuelAdjust1,
//               this.afterElectricFund1,
//               this.afterTotalBill1
//             ]
//           },
//           {
//             label: '컨설팅 후(III)',
//             backgroundColor: '#C15856',
//             data: [
//               this.assetData.afterBasic2,
//               this.sumAfterLoad2,
//               this.assetData.afterHeavyLoad2,
//               this.assetData.afterMaxLoad2,
//               this.assetData.afterLightLoad2,
//               this.assetData.afterEnvironment2,
//               this.assetData.afterAutoDiscount2,
//               this.assetData.afterFuelAdjust2,
//               this.afterElectricFund2,
//               this.afterTotalBill2
//             ]
//           }
//         ],
//       }
//
//       const options = {
//         scales: {
//           yAxes: [
//             {
//               ticks: {
//                 callback: function (value) {
//                   return value / 10000 + '만'
//                 }
//               }
//             }
//           ]
//         }
//       }
//       this.renderChart(chartData, options)
//     },
//     doFocus: function ($event) {
//       if ($event.target.parentElement.className.indexOf('focus') >= 0) {
//         $event.target.parentElement.setAttribute('class', '')
//       } else {
//         $event.target.parentElement.setAttribute('class', 'focus')
//       }
//     },
//     getAssetData: async function () {
//       const res = await this.$AssetSvc.getAssetData({assetNo: this.assetNo})
//       const code = res.code
//       const message = res.message
//       const entity = res.entity
//
//       console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
//
//       if (code === 1) {
//         this.assetData = entity
//         this.customerType = entity.customerType
//       }
//     }
//   }
// }
</script>
